/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

export type CompoundCompoundRecordsAggregateBoolExp = {
  count?: CompoundCompoundRecordsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "compound.compound_records" */
export type CompoundCompoundRecordsAggregateOrderBy = {
  avg?: CompoundCompoundRecordsAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: CompoundCompoundRecordsMaxOrderBy | null | undefined;
  min?: CompoundCompoundRecordsMinOrderBy | null | undefined;
  stddev?: CompoundCompoundRecordsStddevOrderBy | null | undefined;
  stddevPop?: CompoundCompoundRecordsStddevPopOrderBy | null | undefined;
  stddevSamp?: CompoundCompoundRecordsStddevSampOrderBy | null | undefined;
  sum?: CompoundCompoundRecordsSumOrderBy | null | undefined;
  varPop?: CompoundCompoundRecordsVarPopOrderBy | null | undefined;
  varSamp?: CompoundCompoundRecordsVarSampOrderBy | null | undefined;
  variance?: CompoundCompoundRecordsVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsAvgOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "compound.compound_records". All fields are combined with a logical 'AND'. */
export type CompoundCompoundRecordsBoolExp = {
  _and?: Array<CompoundCompoundRecordsBoolExp> | null | undefined;
  _not?: CompoundCompoundRecordsBoolExp | null | undefined;
  _or?: Array<CompoundCompoundRecordsBoolExp> | null | undefined;
  categoryIdArray?: UuidArrayComparisonExp | null | undefined;
  categoryNameArray?: StringArrayComparisonExp | null | undefined;
  compoundRecordMetadataId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestampComparisonExp | null | undefined;
  date?: StringComparisonExp | null | undefined;
  dateArray?: StringArrayComparisonExp | null | undefined;
  dateJdn?: IntComparisonExp | null | undefined;
  dateJdnArray?: IntArrayComparisonExp | null | undefined;
  endDate?: StringComparisonExp | null | undefined;
  endDateArray?: StringArrayComparisonExp | null | undefined;
  endDateJdn?: IntComparisonExp | null | undefined;
  endDateJdnArray?: IntArrayComparisonExp | null | undefined;
  geoLocationArray?: JsonbArrayComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  key?: StringComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  nameArray?: StringArrayComparisonExp | null | undefined;
  nameJa?: StringComparisonExp | null | undefined;
  nameJaArray?: StringArrayComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  recordIdArray?: UuidArrayComparisonExp | null | undefined;
  recordType?: StringComparisonExp | null | undefined;
  referenceArray?: JsonbArrayComparisonExp | null | undefined;
  sourceCompoundEntity?: CompoundCompoundRecordsBoolExp | null | undefined;
  sourceCompoundRelations?: CompoundCompoundRecordsBoolExp | null | undefined;
  sourceCompoundRelationsAggregate?: CompoundCompoundRecordsAggregateBoolExp | null | undefined;
  sourceId?: UuidComparisonExp | null | undefined;
  targetCompoundEntity?: CompoundCompoundRecordsBoolExp | null | undefined;
  targetCompoundRelations?: CompoundCompoundRecordsBoolExp | null | undefined;
  targetCompoundRelationsAggregate?: CompoundCompoundRecordsAggregateBoolExp | null | undefined;
  targetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestampComparisonExp | null | undefined;
  v?: StringComparisonExp | null | undefined;
};

/** order by max() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsMaxOrderBy = {
  categoryIdArray?: OrderBy | null | undefined;
  categoryNameArray?: OrderBy | null | undefined;
  compoundRecordMetadataId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  date?: OrderBy | null | undefined;
  dateArray?: OrderBy | null | undefined;
  dateJdn?: OrderBy | null | undefined;
  dateJdnArray?: OrderBy | null | undefined;
  endDate?: OrderBy | null | undefined;
  endDateArray?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
  endDateJdnArray?: OrderBy | null | undefined;
  geoLocationArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  key?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  nameArray?: OrderBy | null | undefined;
  nameJa?: OrderBy | null | undefined;
  nameJaArray?: OrderBy | null | undefined;
  recordIdArray?: OrderBy | null | undefined;
  recordType?: OrderBy | null | undefined;
  referenceArray?: OrderBy | null | undefined;
  sourceId?: OrderBy | null | undefined;
  targetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  v?: OrderBy | null | undefined;
};

/** order by min() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsMinOrderBy = {
  categoryIdArray?: OrderBy | null | undefined;
  categoryNameArray?: OrderBy | null | undefined;
  compoundRecordMetadataId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  date?: OrderBy | null | undefined;
  dateArray?: OrderBy | null | undefined;
  dateJdn?: OrderBy | null | undefined;
  dateJdnArray?: OrderBy | null | undefined;
  endDate?: OrderBy | null | undefined;
  endDateArray?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
  endDateJdnArray?: OrderBy | null | undefined;
  geoLocationArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  key?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  nameArray?: OrderBy | null | undefined;
  nameJa?: OrderBy | null | undefined;
  nameJaArray?: OrderBy | null | undefined;
  recordIdArray?: OrderBy | null | undefined;
  recordType?: OrderBy | null | undefined;
  referenceArray?: OrderBy | null | undefined;
  sourceId?: OrderBy | null | undefined;
  targetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  v?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "compound.compound_records". */
export type CompoundCompoundRecordsOrderBy = {
  categoryIdArray?: OrderBy | null | undefined;
  categoryNameArray?: OrderBy | null | undefined;
  compoundRecordMetadataId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  date?: OrderBy | null | undefined;
  dateArray?: OrderBy | null | undefined;
  dateJdn?: OrderBy | null | undefined;
  dateJdnArray?: OrderBy | null | undefined;
  endDate?: OrderBy | null | undefined;
  endDateArray?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
  endDateJdnArray?: OrderBy | null | undefined;
  geoLocationArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  key?: OrderBy | null | undefined;
  metadata?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  nameArray?: OrderBy | null | undefined;
  nameJa?: OrderBy | null | undefined;
  nameJaArray?: OrderBy | null | undefined;
  properties?: OrderBy | null | undefined;
  recordIdArray?: OrderBy | null | undefined;
  recordType?: OrderBy | null | undefined;
  referenceArray?: OrderBy | null | undefined;
  sourceCompoundEntity?: CompoundCompoundRecordsOrderBy | null | undefined;
  sourceCompoundRelationsAggregate?: CompoundCompoundRecordsAggregateOrderBy | null | undefined;
  sourceId?: OrderBy | null | undefined;
  targetCompoundEntity?: CompoundCompoundRecordsOrderBy | null | undefined;
  targetCompoundRelationsAggregate?: CompoundCompoundRecordsAggregateOrderBy | null | undefined;
  targetId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  v?: OrderBy | null | undefined;
};

/** select columns of table "compound.compound_records" */
export type CompoundCompoundRecordsSelectColumn =
  /** column name */
  | 'categoryIdArray'
  /** column name */
  | 'categoryNameArray'
  /** column name */
  | 'compoundRecordMetadataId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'date'
  /** column name */
  | 'dateArray'
  /** column name */
  | 'dateJdn'
  /** column name */
  | 'dateJdnArray'
  /** column name */
  | 'endDate'
  /** column name */
  | 'endDateArray'
  /** column name */
  | 'endDateJdn'
  /** column name */
  | 'endDateJdnArray'
  /** column name */
  | 'geoLocationArray'
  /** column name */
  | 'id'
  /** column name */
  | 'key'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'nameArray'
  /** column name */
  | 'nameJa'
  /** column name */
  | 'nameJaArray'
  /** column name */
  | 'properties'
  /** column name */
  | 'recordIdArray'
  /** column name */
  | 'recordType'
  /** column name */
  | 'referenceArray'
  /** column name */
  | 'sourceId'
  /** column name */
  | 'targetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'v';

/** order by stddev() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevPopOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevSampOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsSumOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarPopOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarSampOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarianceOrderBy = {
  dateJdn?: OrderBy | null | undefined;
  endDateJdn?: OrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<number> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<number> | null | undefined;
  _eq?: Array<number> | null | undefined;
  _gt?: Array<number> | null | undefined;
  _gte?: Array<number> | null | undefined;
  _in?: Array<Array<number>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<number> | null | undefined;
  _lte?: Array<number> | null | undefined;
  _neq?: Array<number> | null | undefined;
  _nin?: Array<Array<number>> | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<Types.JsonObject> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<Types.JsonObject> | null | undefined;
  _eq?: Array<Types.JsonObject> | null | undefined;
  _gt?: Array<Types.JsonObject> | null | undefined;
  _gte?: Array<Types.JsonObject> | null | undefined;
  _in?: Array<Array<Types.JsonObject>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<Types.JsonObject> | null | undefined;
  _lte?: Array<Types.JsonObject> | null | undefined;
  _neq?: Array<Types.JsonObject> | null | undefined;
  _nin?: Array<Array<Types.JsonObject>> | null | undefined;
};

export type JsonbCastExp = {
  String?: StringComparisonExp | null | undefined;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: JsonbCastExp | null | undefined;
  /** is the column contained in the given json value */
  _containedIn?: Types.JsonObject | null | undefined;
  /** does the column contain the given json value at the top level */
  _contains?: Types.JsonObject | null | undefined;
  _eq?: Types.JsonObject | null | undefined;
  _gt?: Types.JsonObject | null | undefined;
  _gte?: Types.JsonObject | null | undefined;
  /** does the string exist as a top-level key in the column */
  _hasKey?: string | null | undefined;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: Array<string> | null | undefined;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: Array<string> | null | undefined;
  _in?: Array<Types.JsonObject> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Types.JsonObject | null | undefined;
  _lte?: Types.JsonObject | null | undefined;
  _neq?: Types.JsonObject | null | undefined;
  _nin?: Array<Types.JsonObject> | null | undefined;
};

/** column ordering options */
export type OrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST';

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: Array<OrganizationsBoolExp> | null | undefined;
  _not?: OrganizationsBoolExp | null | undefined;
  _or?: Array<OrganizationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  kind?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenants?: TenantsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  kind?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  tenantsAggregate?: TenantsAggregateOrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "product_roles". All fields are combined with a logical 'AND'. */
export type ProductRolesBoolExp = {
  _and?: Array<ProductRolesBoolExp> | null | undefined;
  _not?: ProductRolesBoolExp | null | undefined;
  _or?: Array<ProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type ProductsBoolExp = {
  _and?: Array<ProductsBoolExp> | null | undefined;
  _not?: ProductsBoolExp | null | undefined;
  _or?: Array<ProductsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  importDirectWebhookUrl?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  originHosts?: StringComparisonExp | null | undefined;
  productRoles?: ProductRolesBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: Array<RolesBoolExp> | null | undefined;
  _not?: RolesBoolExp | null | undefined;
  _or?: Array<RolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _isNull?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

/** order by aggregate values of table "tenant_product_installations" */
export type TenantProductInstallationsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: TenantProductInstallationsMaxOrderBy | null | undefined;
  min?: TenantProductInstallationsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "tenant_product_installations". All fields are combined with a logical 'AND'. */
export type TenantProductInstallationsBoolExp = {
  _and?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  _not?: TenantProductInstallationsBoolExp | null | undefined;
  _or?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  visibility?: StringComparisonExp | null | undefined;
};

/** order by max() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  visibility?: OrderBy | null | undefined;
};

/** order by min() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  visibility?: OrderBy | null | undefined;
};

/** order by aggregate values of table "tenants" */
export type TenantsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: TenantsMaxOrderBy | null | undefined;
  min?: TenantsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: Array<TenantsBoolExp> | null | undefined;
  _not?: TenantsBoolExp | null | undefined;
  _or?: Array<TenantsBoolExp> | null | undefined;
  allowAutoApproveChangeRequests?: BooleanComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  ownerUser?: UsersBoolExp | null | undefined;
  ownerUserId?: UuidComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenantProductInstallations?: TenantProductInstallationsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
};

/** order by max() on columns of table "tenants" */
export type TenantsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "tenants" */
export type TenantsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "tenants". */
export type TenantsOrderBy = {
  allowAutoApproveChangeRequests?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organization?: OrganizationsOrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUser?: UsersOrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  tenantProductInstallationsAggregate?: TenantProductInstallationsAggregateOrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateOrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: unknown;
  _gt?: unknown;
  _gte?: unknown;
  _in?: Array<unknown> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: unknown;
  _lte?: unknown;
  _neq?: unknown;
  _nin?: Array<unknown> | null | undefined;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: Array<UserGroupsBoolExp> | null | undefined;
  _not?: UserGroupsBoolExp | null | undefined;
  _or?: Array<UserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  users?: UserUserGroupsBoolExp | null | undefined;
};

/** order by aggregate values of table "user_product_roles" */
export type UserProductRolesAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserProductRolesMaxOrderBy | null | undefined;
  min?: UserProductRolesMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_roles". All fields are combined with a logical 'AND'. */
export type UserProductRolesBoolExp = {
  _and?: Array<UserProductRolesBoolExp> | null | undefined;
  _not?: UserProductRolesBoolExp | null | undefined;
  _or?: Array<UserProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_product_roles" */
export type UserProductRolesMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  roleId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_product_roles" */
export type UserProductRolesMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  roleId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_segments". All fields are combined with a logical 'AND'. */
export type UserSegmentsBoolExp = {
  _and?: Array<UserSegmentsBoolExp> | null | undefined;
  _not?: UserSegmentsBoolExp | null | undefined;
  _or?: Array<UserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: IntComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type UserTenantsAggregateBoolExp = {
  count?: UserTenantsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "user_tenants" */
export type UserTenantsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserTenantsMaxOrderBy | null | undefined;
  min?: UserTenantsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: Array<UserTenantsBoolExp> | null | undefined;
  _not?: UserTenantsBoolExp | null | undefined;
  _or?: Array<UserTenantsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  role?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_tenants" */
export type UserTenantsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  role?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_tenants" */
export type UserTenantsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  role?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** select columns of table "user_tenants" */
export type UserTenantsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'role'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'userId';

/** order by aggregate values of table "user_user_groups" */
export type UserUserGroupsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserUserGroupsMaxOrderBy | null | undefined;
  min?: UserUserGroupsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_groups". All fields are combined with a logical 'AND'. */
export type UserUserGroupsBoolExp = {
  _and?: Array<UserUserGroupsBoolExp> | null | undefined;
  _not?: UserUserGroupsBoolExp | null | undefined;
  _or?: Array<UserUserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userGroup?: UserGroupsBoolExp | null | undefined;
  userGroupId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_user_groups" */
export type UserUserGroupsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userGroupId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_user_groups" */
export type UserUserGroupsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userGroupId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by aggregate values of table "user_user_segments" */
export type UserUserSegmentsAggregateOrderBy = {
  avg?: UserUserSegmentsAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: UserUserSegmentsMaxOrderBy | null | undefined;
  min?: UserUserSegmentsMinOrderBy | null | undefined;
  stddev?: UserUserSegmentsStddevOrderBy | null | undefined;
  stddevPop?: UserUserSegmentsStddevPopOrderBy | null | undefined;
  stddevSamp?: UserUserSegmentsStddevSampOrderBy | null | undefined;
  sum?: UserUserSegmentsSumOrderBy | null | undefined;
  varPop?: UserUserSegmentsVarPopOrderBy | null | undefined;
  varSamp?: UserUserSegmentsVarSampOrderBy | null | undefined;
  variance?: UserUserSegmentsVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "user_user_segments" */
export type UserUserSegmentsAvgOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_segments". All fields are combined with a logical 'AND'. */
export type UserUserSegmentsBoolExp = {
  _and?: Array<UserUserSegmentsBoolExp> | null | undefined;
  _not?: UserUserSegmentsBoolExp | null | undefined;
  _or?: Array<UserUserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  userSegment?: UserSegmentsBoolExp | null | undefined;
  userSegmentId?: IntComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_user_segments" */
export type UserUserSegmentsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  userSegmentId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_user_segments" */
export type UserUserSegmentsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddev() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevPopOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevSampOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "user_user_segments" */
export type UserUserSegmentsSumOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "user_user_segments" */
export type UserUserSegmentsVarPopOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsVarSampOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "user_user_segments" */
export type UserUserSegmentsVarianceOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: Array<UsersBoolExp> | null | undefined;
  _not?: UsersBoolExp | null | undefined;
  _or?: Array<UsersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  displayName?: StringComparisonExp | null | undefined;
  email?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  memo?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  photoUrl?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
  userUserGroups?: UserUserGroupsBoolExp | null | undefined;
  userUserSegments?: UserUserSegmentsBoolExp | null | undefined;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  displayName?: OrderBy | null | undefined;
  email?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  memo?: OrderBy | null | undefined;
  organization?: OrganizationsOrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  photoUrl?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userProductRolesAggregate?: UserProductRolesAggregateOrderBy | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateOrderBy | null | undefined;
  userUserGroupsAggregate?: UserUserGroupsAggregateOrderBy | null | undefined;
  userUserSegmentsAggregate?: UserUserSegmentsAggregateOrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type CompoundCompoundRecordsAggregateBoolExpCount = {
  arguments?: Array<CompoundCompoundRecordsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: CompoundCompoundRecordsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: Array<UserTenantsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserTenantsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type GetCompoundEntitiesForTimelineQueryVariables = Exact<{
  tenantId: string;
  limit?: number | null | undefined;
  offset?: number;
  where?: Types.CompoundCompoundRecordsBoolExp | null | undefined;
  orderBy?: Array<Types.CompoundCompoundRecordsOrderBy> | Types.CompoundCompoundRecordsOrderBy | null | undefined;
}>;


export type GetCompoundEntitiesForTimelineQuery = { compoundCompoundRecords: Array<{ __typename: 'CompoundCompoundRecords', id: string, name: string | null, nameJa: string | null, date: string | null, endDate: string | null, categoryNameArray: Array<string> }> };


export const GetCompoundEntitiesForTimelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompoundEntitiesForTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"2147483647"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompoundCompoundRecordsBoolExp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompoundCompoundRecordsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compoundCompoundRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameJa"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNameArray"}}]}}]}}]} as unknown as DocumentNode<GetCompoundEntitiesForTimelineQuery, GetCompoundEntitiesForTimelineQueryVariables>;